"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPhoneNumberTypeSimplified = exports.EPhoneNumberFormat = exports.EPhoneNumberType = void 0;
var EPhoneNumberType;
(function (EPhoneNumberType) {
    EPhoneNumberType["FIXED_LINE"] = "FIXED_LINE";
    EPhoneNumberType["MOBILE"] = "MOBILE ";
    EPhoneNumberType["FIXED_LINE_OR_MOBILE"] = "FIXED_LINE_OR_MOBILE";
    EPhoneNumberType["TOLL_FREE"] = "TOLL_FREE";
    EPhoneNumberType["PREMIUM_RATE"] = "PREMIUM_RATE";
    EPhoneNumberType["SHARED_COST"] = "SHARED_COST";
    EPhoneNumberType["VOIP"] = "VOIP";
    EPhoneNumberType["PERSONAL_NUMBER"] = "PERSONAL_NUMBER";
    EPhoneNumberType["PAGER"] = "PAGER";
    EPhoneNumberType["UAN"] = "UAN";
    EPhoneNumberType["VOICEMAIL"] = "VOICEMAIL";
    EPhoneNumberType["UNKNOWN"] = "UNKNOWN";
})(EPhoneNumberType || (exports.EPhoneNumberType = EPhoneNumberType = {}));
/**
 * Форматы телефонных номеров
 */
var EPhoneNumberFormat;
(function (EPhoneNumberFormat) {
    /**
     * @example +12133734253
     */
    EPhoneNumberFormat["E164"] = "E164";
    /**
     * @example +1 213 373 4253
     */
    EPhoneNumberFormat["INTERNATIONAL"] = "INTERNATIONAL";
    /**
     * @example (213) 373-4253
     */
    EPhoneNumberFormat["NATIONAL"] = "NATIONAL";
    /**
     * @example tel:+12133734253;ext=123
     */
    EPhoneNumberFormat["RFC3966"] = "RFC3966";
})(EPhoneNumberFormat || (exports.EPhoneNumberFormat = EPhoneNumberFormat = {}));
var EPhoneNumberTypeSimplified;
(function (EPhoneNumberTypeSimplified) {
    EPhoneNumberTypeSimplified["mobile"] = "mobile";
    EPhoneNumberTypeSimplified["home"] = "home";
    EPhoneNumberTypeSimplified["work"] = "work";
})(EPhoneNumberTypeSimplified || (exports.EPhoneNumberTypeSimplified = EPhoneNumberTypeSimplified = {}));
//# sourceMappingURL=phone-number.enums.js.map